import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { Elements } from "@stripe/react-stripe-js";
import { axiosInstance } from "../../api/axiosDefaults";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Button, Row, Form } from "react-bootstrap";
import BillingDetailsFields from "./BillingDetailsFields";
import CardElementContainer from "./CardElementContainer";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import toast from "react-hot-toast";
import { Link, useHistory } from "react-router-dom";
import StripeImage from "../../assets/stripe-logo-company.png";
import styles from "../../styles/Account.module.css";
import {
  confirmSubscriptionPaymentAction,
  getCreateCustomerPayload,
  getPaymentActionClientSecret,
  subscriptionPaymentSucceeded,
  subscriptionRequiresPaymentAction,
} from "./stripeSubscriptionActions";

const cardElementOptions = {
  style: {
    base: {
      fontSize: "16px",
      fontWeight: 400,
      color: "#050F2F",
      "::placeholder": {
        color: "#9A98A8",
      },
    },
    invalid: {
      color: "#f54e4e",
      iconColor: "#f54e4e",
    },
  },
  hidePostalCode: true,
};

export default function PaymentPage() {
  const currentUser = useCurrentUser();
  const history = useHistory();
  const params = useParams();
  const [processingPayment, setProcessingPayment] = useState(false);
  const [planId, setPlanId] = useState("");
  // const [paymentAmount, setPaymentAmount] = useState(0);
  const [formData, setFormData] = useState({
    addressLine1: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    currency: null
  });
  const [accepted, setAccepted] = useState(false);

  const stripe = useStripe();
  const elements = useElements();
  const redirectToSubscriptionSync = () => {
    history.push(`/subscription-plans?payment_sync=pending`);
  };
  // const currencyParts = formData?.currency?.split(",");
  // const currencySymbol = currencyParts?.[1] || "$";

  // const getPaymentIntent = async (plan_id, plan_name) => {
  //   try {
  //     // const response = await axiosInstance.get(`user/payment-methods/intent`)
  //     const response = await axiosInstance.post(
  //       `/create-payment-intent/`,
  //       { plan_id, plan_name },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //         },
  //         withCredentials: true,
  //       }
  //     );

  //     console.log(response);
  //     setClientSecret(response.data.data.client_secret);
  //     setPaymentIntentId(response.data.data.payment_intent_id);
  //   } catch (error) {
  //     console.error("Error fetching feeds:", error);
  //   } finally {
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessingPayment(true);

    if (!accepted) {
      toast.error("Please accept terms and conditions!");
      setProcessingPayment(false);

      return;
    }

    if (
      !formData.city ||
      !formData.country ||
      !formData.addressLine1 ||
      !formData.postalCode ||
      !formData.state
    ) {
      setProcessingPayment(false);
      toast.error("All the fields are required!");
      return;
    }
    const cardElement = elements.getElement(CardElement);
    if (!stripe || !elements || !cardElement) {
      setProcessingPayment(false);
      toast.error("Payment form is not ready. Please try again.");
      return;
    }

    const body = {
      name: currentUser?.username,
      email: currentUser?.email,
      address: {
        city: formData.city,
        state: formData.state,
        line1: formData.addressLine1,
        line2: "",
        postal_code: formData.postalCode,
      },
    };
    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: body,
      // currency: formData?.currency?.split(',')[0].toLowerCase() ?? "usd"
    });
    if (error) {
      setProcessingPayment(false);
      toast.error(error.message || "Payment method failed.");
    } else {
      const { id } = paymentMethod;
      // console.log("payment method id: ", id);

      // calling create customer api
      try {
        const res = await axiosInstance.post(
          `/create-customer/`,
          {
            plan_id: planId,
            subscription_type: "project",
            currency: formData?.currency?.split(',')[0]?.toLowerCase() ?? "usd",
            customer_details: {
              payment_method: id,
              address_line1: formData.addressLine1,
              city: formData.city,
              state: formData.state,
              country: formData?.country,
              postal_code: formData.postalCode,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );

        const payload = getCreateCustomerPayload(res);

        if (subscriptionRequiresPaymentAction(payload)) {
          const actionClientSecret = getPaymentActionClientSecret(payload);

          if (!actionClientSecret) {
            toast.error("Payment needs authentication, but no client secret was returned.");
            return;
          }

          const { error: confirmError, paymentIntent } =
            await confirmSubscriptionPaymentAction(stripe, actionClientSecret);

          if (confirmError) {
            toast.error(confirmError.message || "Payment authentication failed.");
            return;
          }

          if (paymentIntent?.status === "succeeded") {
            redirectToSubscriptionSync();
            toast.success("Payment successful");
            return;
          }

          toast.error("Payment authentication was not completed.");
          return;
        }

        if (subscriptionPaymentSucceeded(payload)) {
          redirectToSubscriptionSync();
          toast.success(
            payload?.subscription?.status === "trialing"
              ? "Trial period started"
              : "Payment successful"
          );
          return;
        }

        toast.error("Subscription failed!");
      } catch (err) {
        toast.error("Subscription failed!");
      } finally {
        setProcessingPayment(false);
      }
    }

    // console.log(paymentMethod)
  };

  // const fetchData = async (pId, cId) => {
  //   try {
  //     const response = await axiosInstance.get(`/plans/`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //       },
  //       withCredentials: true,
  //     });

  //     if (response?.data?.status === 200) {
  //       const plans = response?.data?.data?.filter(
  //         (p) => p?.category?.id === Number(cId)
  //       )[0]?.plans;
  //       const plan = plans?.find((p) => p?.id === pId);

  //       setPaymentAmount(plan?.price || 0);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    setPlanId(params?.planId);
    // if (params?.planId && params?.planName) {
    //   getPaymentIntent(params?.planId, params?.planName);
    // }
    // if (params?.planId && params?.categoryId) {
    //   fetchData(params?.planId, params?.categoryId);
    // }
  }, [params]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="py-2">
      <div
        style={{
          maxWidth: "800px",
          margin: "1rem auto",
          padding: "1rem",
        }}
      >
        <form
          style={{
            display: "flex",
            flexDirection: "column",
          }}
          onSubmit={handleSubmit}
        >
          {/* <div className="col-12"> */}
          <Row>
            <CardElementContainer cardElementOptions={cardElementOptions} />
          </Row>
          {/* </div> */}

          <BillingDetailsFields
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
            // formError={formError}
            // stateList={stateList}
            isInlineValidation={true}
          />

          <div className="col-12">
            <div className="mt-2 row">
              <div className="col-12">
                <Form.Group controlId="termsConditions">
                  <Form.Check
                    type="checkbox"
                    label={
                      <>
                        I accept the{" "}
                        <Link className={styles.Link1} to="/terms-and-conditions">
                        Terms of Service
                        </Link>
                          {/* <a
                          href="/terms-and-conditions"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service
                        </a> */}
                      </>
                    }
                    checked={accepted}
                    onChange={(e) => setAccepted(e.target.checked)}
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Row
                  style={{
                    marginBottom: "1rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      width: "100%",
                    }}
                  > */}
                  <div style={{ display: "inline-block" }}>
                    Your data is safe with
                  </div>
                  {/* </div> */}
                  <img src={StripeImage} height={30} alt="Stripe" />
                </Row>
                <Button type="submit" disabled={processingPayment}>
                  {/* {processingPayment
                    ? "Processing payment"
                    : paymentAmount
                    ? `Pay ${currencySymbol} ${paymentAmount} Now`
                    : "Submit"} */}
                  {processingPayment ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
